// @flow
import type { AuthViewer } from 'app/packages/pinterest-flow-types/viewer';
import { canPinnerPromote } from 'app/common/lib/BusinessUtil';
import { toMaybeHasBuyableProduct as hasBuyableProduct } from 'app/common/react/components/closeup/lib';
import { hasPin, hasVideo } from 'app/common/react/components/closeup/utils';

// TODO(CUI-3810):
// The logic of these utils seems like it is probably common
// to other places that deal Pin objects. See about cleaning up/consolidating

// Closeup currently types this.props.pin as Object
// This will need to be update if closeup gets tighter typing
type Pin = Object;

export function creatorId(pin: Pin) {
  const {
    third_party_pin_owner: thirdPartyPinOwner,
    link_domain: linkDomain,
    pinner,
    domain,
  } = pin;

  if (!!pinner && pinner.domain_verified && pinner.domain_url === domain) {
    return pinner.id;
  }

  const officialUser = linkDomain && linkDomain.official_user;
  if (!officialUser && !thirdPartyPinOwner) {
    return pin.native_creator && pin.native_creator.id;
  }

  return officialUser ? officialUser.id : thirdPartyPinOwner.id;
}

export function hasCanonicalData(pin: Pin) {
  return (
    pin &&
    Object.keys(pin.aggregated_pin_data || {}).length !== 0 &&
    Object.keys(pin.aggregated_pin_data.creator_analytics || {}).length !== 0
  );
}

export function hasRootPinData(pin: Pin) {
  return pin && Object.keys(pin.creator_analytics || {}).length !== 0;
}

export function isShopTheLook(pin: Pin) {
  const aggregatedPinData = pin.aggregated_pin_data || {};
  return aggregatedPinData.is_shop_the_look || aggregatedPinData.is_stela;
}

export function showCreatorCard(pin: Pin) {
  const { native_creator: nativeCreator, pinner, domain } = pin;
  const hasPinObj = hasPin({ pin });
  const { buyableProduct } = hasBuyableProduct(hasPinObj) || {};
  const linksToClaimedSiteOrThirdParty =
    ((pin.link_domain && pin.link_domain.official_user) ||
      !!pin.third_party_pin_owner ||
      (!!pinner && pinner.domain_verified && pinner.domain_url === domain)) &&
    !buyableProduct &&
    !pin.is_promoted;

  return linksToClaimedSiteOrThirdParty || nativeCreator;
}

export function hasMorePinDetails(pin: Pin, isLandingPage: boolean) {
  const { is_native: isNative, native_pin_stats } = pin;
  const nativePinStats = native_pin_stats || {};
  const hasPinObj = hasPin({ pin });
  const { buyableProduct } = hasBuyableProduct(hasPinObj) || {};
  const { video } = hasVideo(hasPinObj) || {};
  return (
    showCreatorCard(pin) ||
    isShopTheLook(pin) ||
    (isNative && video && pin && pin.link) ||
    (Object.keys(nativePinStats).length > 0 && !hasCanonicalData(pin) && !hasRootPinData(pin)) ||
    (!isShopTheLook(pin) && buyableProduct) ||
    (pin.promoter && pin.is_promoted && !isLandingPage)
  );
}

type ShouldShowPromoteButtonToPinnerArgs = {|
  pin: Pin,
  viewer: AuthViewer,
|};

export const shouldShowPromoteButtonToPinner = ({
  viewer,
  pin,
}: ShouldShowPromoteButtonToPinnerArgs): boolean =>
  canPinnerPromote(viewer) && pin.is_quick_promotable_by_pinner;

export default null;
